import loggingService from '../util/loggingService'

var path = '/Lookup/'
var isDebug = false

const LookupEnum = {
    Unknown: 9998,
    Other: 9999
}

const YesNoUnknownEnum = {
    Yes: 1,
    No: 2,
    Unknown: 3,
    NotApplicable: 4
}

const CauseOfDeathEnum = {
    AbuseNeglect: 1,
    Aircraft: 2,
    Autoerotic: 3,
    BurnsFire: 4,
    COPoisoning: 5,
    Drowning: 6,
    DrugOverdose: 7,
    Electrical: 8,
    Exposure: 9,
    FallJump: 10,
    Gunshot: 11,
    Hanging: 12,
    IncisedStabWounds: 13,
    JobRelated: 14,
    Strangulation: 15,
    Poisoning: 16,
    Suicide: 17,
    Vehicular: 18
}

const YesNoUnknownList = [
    { id: 1, description: 'Yes' },
    { id: 2, description: 'No' },
    { id: 3, description: 'Unknown' }
]

const YesNoUnknownNaList = [
    { id: 1, description: 'Yes' },
    { id: 2, description: 'No' },
    { id: 3, description: 'Unknown' },
    { id: 4, description: 'N/A' }
]

const YesNoList = [
    { id: 1, description: 'Yes' },
    { id: 2, description: 'No' }
]

const YesNoNaList = [
    { id: 1, description: 'Yes' },
    { id: 2, description: 'No' },
    { id: 4, description: 'N/A' }
]

const YesNoUndeterminedList = [
    { id: 1, description: 'Yes' },
    { id: 2, description: 'No' },
    { id: 3, description: 'Undetermined' }
]

const YesNoUndeterminedNaList = [
    { id: 1, description: 'Yes' },
    { id: 2, description: 'No' },
    { id: 3, description: 'Undetermined' },
    { id: 4, description: 'N/A' }
]

const FullTimePartTimeList = [
    { id: 1, description: 'Full Time' },
    { id: 2, description: 'Part Time' }
]

const AutopsyFullPartialList = [
    { id: 1, description: 'Full' },
    { id: 2, description: 'Partial' }
]

function listLookup (http, type) {
    loggingService.log(isDebug, 'Lookup service', 'Lookup on: ' + type)
    return http.get(path + type)
}

function listCauseOfDeathItem (http, categoryId) {
    loggingService.log(isDebug, 'Lookup service', 'CauseOfDeathItem category: ' + categoryId)
    return http.get(path + 'CauseOfDeathItem?categoryId=' + categoryId)
}

function getCauseOfDeathFormCategoryItems (http, causeOfDeathId) {
    loggingService.log(isDebug, 'Lookup service', 'CauseOfDeathFormCategoryItems id: ' + causeOfDeathId)
    return http.get(path + 'CauseOfDeathFormCategoryItems?causeOfDeathId=' + causeOfDeathId)
}

function getEthnicityList (http) {
    loggingService.log(isDebug, 'Lookup service', 'Get Ethnicity List')
    return http.get(path + 'GetEthnicityList')
}

function getDispositionPermitTypes (http) {
    loggingService.log(isDebug, 'Lookup Service', 'Get Disposition Permit Types')
    return http.get(path + 'GetDispositionPermitTypes')
}

export default {
    listLookup: listLookup,
    listCauseOfDeathItem: listCauseOfDeathItem,
    getCauseOfDeathFormCategoryItems: getCauseOfDeathFormCategoryItems,
    getEthnicityList: getEthnicityList,
    LookupEnum: LookupEnum,
    YesNoUnknownEnum: YesNoUnknownEnum,
    CauseOfDeathEnum: CauseOfDeathEnum,
    YesNoUnknownList: YesNoUnknownList,
    YesNoUnknownNaList: YesNoUnknownNaList,
    YesNoNaList: YesNoNaList,
    YesNoList: YesNoList,
    YesNoUndeterminedList: YesNoUndeterminedList,
    YesNoUndeterminedNaList: YesNoUndeterminedNaList,
    FullTimePartTimeList: FullTimePartTimeList,
    AutopsyFullPartialList: AutopsyFullPartialList,
    getDispositionPermitTypes: getDispositionPermitTypes
}
